import type { Account } from '@/widgets/Wizard/models/accounts';

export function matchAccountConfigThroughHostname(hostname: string, accounts: Account[]): Account | null {
    if (accounts.length === 0) {
        return null;
    }

    const account = accounts.find((account) => account.hosts.includes(hostname));

    return !account ? null : account;
}
